<template>
    <div>
        <div
            class="flex items-center overflow-hidden rounded-lg border border-theme-border bg-theme-hover p-2"
        >
            <component
                :is="cardComponent"
                :product="sampleProduct"
                class="pointer-events-none"
            />
        </div>
        <p class="mt-2 text-left text-sm font-medium text-theme-base">
            {{ option.label }}
        </p>
    </div>
</template>

<script>
import { productCardComponents } from "@/components/catalog/product-sliders";

// Sin `slug`: cada `ProductItemN` degrada a `<div>` en vez de `<a>` cuando
// falta el slug (mismo comportamiento defensivo que ya usan por si el
// producto real no lo trajera) — evita anidar un link dentro del `<button>`
// de `ProductItemDesignSelector.vue`.
const SAMPLE_PRODUCT = {
    name: "Producto de ejemplo",
    references: [
        {
            price: 45000,
            priceOffer: 0,
            images: [
                {
                    url: "/img/default/product_1.webp",
                    alt: "Producto de ejemplo"
                }
            ]
        }
    ]
};

export default {
    name: "ProductItemDesignSwatch",
    props: {
        option: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            sampleProduct: SAMPLE_PRODUCT
        };
    },
    computed: {
        cardComponent() {
            return productCardComponents[this.option.value];
        }
    }
};
</script>
